import React, { Fragment } from "react";
// Import your exact native design layout modules
import ModalModern from "../../../../../../components/ui/popup/ModalModern";
import ModernPopupHeader from "../../../../../../components/ui/popup/common/ModernPopupHeader";
import ModernPopupBody from "../../../../../../components/ui/popup/common/ModernPopupBody";
import { basicPlanFeatures, freePlanFeatures } from "../../plans/plans";

function FeatureComparisonModal({ planName, onClose }) {
  // Select the exact feature array based on your exact active plan profile string
  const isFree = planName?.toLowerCase() === "free";
  const activeFeatures = isFree ? freePlanFeatures : basicPlanFeatures;

  // Use the matching display title matching your system rules
  const displayTitle = isFree
    ? "FINANCIAL INSIGHTS (FREE) FEATURES"
    : "FINANCIAL INSIGHTS (PAID PLAN) FEATURES";

  return (
    <Fragment>
      <ModalModern onClose={onClose}>
        {/* NATIVE DESIGN POPUP HEADER */}
        <ModernPopupHeader onClose={onClose} segmentPaddingButton={false}>
          <div className="header-content-modern-col">
            <h3
              className="transaction-popup-title"
              style={{ margin: 0, textTransform: "uppercase" }}
            >
              {displayTitle}
            </h3>
          </div>
        </ModernPopupHeader>

        {/* NATIVE DESIGN POPUP BODY */}
        <ModernPopupBody>
          <div className="mp-col-container" style={{ padding: "8px 4px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "100%",
              }}
            >
              {/* Feature Matrix Map Loop */}
              {activeFeatures.map((feat, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    opacity: feat.isAvailable ? 1 : 0.45,
                  }}
                >
                  {/* MODIFIED: Using your exact public image asset strings matching FiPlanCard */}
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icons/${
                      feat.isAvailable
                        ? "check_green.svg"
                        : "close_grey_light.svg"
                    }`}
                    className="faq-card-icon"
                    alt="Feature Icon"
                  />

                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      color: "#40464b",
                      fontWeight: "400",
                    }}
                  >
                    {feat.text}
                    {feat.strongText && (
                      <strong
                        style={{
                          color: "#2b2b2b",
                          marginLeft: "4px",
                          fontWeight: "600",
                        }}
                      >
                        {feat.strongText}
                      </strong>
                    )}
                  </p>
                </div>
              ))}

              {/* Central Action Confirm Button wrapped cleanly inside the body canvas */}
              <button
                onClick={onClose}
                className="cta-button primary"
                style={{
                  marginTop: "16px",
                  width: "100%",
                  padding: "12px",
                  fontWeight: "700",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                <b>Got it</b>
              </button>
            </div>
          </div>
        </ModernPopupBody>
      </ModalModern>
    </Fragment>
  );
}

export default FeatureComparisonModal;
